import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

export enum RegEx {
  USER_ID_REGEX = 'USER_ID_REGEX',
  GRANDFATHERED_USER_ID_REGEX = 'GRANDFATHERED_USER_ID_REGEX',
  PASSWORD_REGEX = 'PASSWORD_REGEX',
}

const KEY_MAP: any = {
  regex_grandfathered_user_id: RegEx.GRANDFATHERED_USER_ID_REGEX,
  regex_password: RegEx.PASSWORD_REGEX,
  regex_user_id: RegEx.USER_ID_REGEX,
};

@Injectable({
  providedIn: 'root',
})
export class RegexService implements Resolve<any> {
  // @ts-ignore
  regex: Record<string, RegExp> = RegEx;

  constructor(private http: HttpClient) {}

  loadRegex() {
    return this.http.get('/utilService/regex');
  }

  get(key: string) {
    return this.regex[key];
  }

  private loadRegexSuccess(res: Record<string, string>) {
    this.regex = Object.entries(res).reduce((acc, [key, value]) => {
      return {
        ...acc,
        [KEY_MAP[key]]: new RegExp(value),
      };
    }, {});
  }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<any> {
    return this.loadRegex().pipe(
      tap((res: any) => this.loadRegexSuccess(res)),
      catchError(() => of([])),
    );
  }
}
